module.exports = __webpack_public_path__ + "static/media/plus-lg.63b66cb4.svg";